import { loading, success, reset, handleErrorException } from 'State/actions';

import * as types from './types';

export const getNutritionStandards = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(
        loading(types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_LOADING, true)
      );

      const response = await MPWWebApi.getGeneric(
        'CycleMenu/GetNutritionStandards'
      );

      dispatch(
        success(
          types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_SUCCESS,
          response.data.Data
        )
      );
    } catch (ex) {
      dispatch(
        handleErrorException(
          ex,
          types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_ERROR,
          { Title: 'Error', Message: 'Unable to get nutrition standards' }
        )
      );
    } finally {
      dispatch(
        loading(types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_LOADING, false)
      );
    }
  };
};

export const clearGetNutritionStandardsResult = () => {
  return (dispatch) => {
    dispatch(reset(types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_SUCCESS, []));
    dispatch(reset(types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_ERROR, null));
  };
};




// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/state/actions.js